import { reduceMsg } from '@/api/Utilities.js'
import { getUserData } from '@/api/FirebaseUserWrapper'
/**
 * 通知ユーティリティ
 */

/**
 * getNotificationMsg:
 *  通知情報から通知するメッセージを生成する
 *
 * @param {Object} data 通知用のデータ
 * @return {html} 通知メッセージ
 */
export async function getNotificationMsg (data) {
  const creatingUserData = await getUserData(data.creatingUserId)
  const issue = reduceMsg(data.targettedIssue, 20)
  const message = reduceMsg(data.notifiedQuestion, 20)
  const number = data.number

  if (data.type === '返信') {
    const content =
    `<div class="issue">
      ${creatingUserData.name}が
      <span class="text has-text-weight-bold">『${issue}』</span>に
      <span class="text has-text-weight-bold">${number}: ${message}</span>と返信しました。
    </div>`
    return content
  } else if (data.type === '公開') {
    const content =
    `<div class="issue">
      ${creatingUserData.name}が
      <span class="text has-text-weight-bold">新しいツリー</span>を公開しました。
    </div>`
    return content
  } else { // type === '付け替え'
    const content =
    `<div class="issue">
      <span class="text has-text-weight-bold">『${issue}』</span>の
      <span class="text has-text-weight-bold">${number}</span>を並び替えしました。
    </div>`
    return content
  }
}

/**
 * getNotificationData:
 *  通知情報があるかどうか未読通知の数を配列で返却
 *
 * @param {Object} data 通知用のデータ
 * @return {array} 未読通知の数, 通知の有無boolean
 */
export function getNotificationData (notifications) {
  if (!notifications) { return }
  const notificationData = notifications
  let notifiedLength = 0
  let hasNotifications = false
  for (const data of notificationData) {
    if (!data.viewFlag) {
      notifiedLength += 1
    }
  }
  // 通知が１個以上あったらv-bind classで通知iconを赤にする
  if (notifiedLength > 0) {
    hasNotifications = true
  }
  return [notifiedLength, hasNotifications]
}



// WEBPACK FOOTER //
// ./src/api/NotificationUtilities.js